// from https://github.com/dsherret/ts-nameof/issues/121
// MHO: mainly used for mui-x-grid, to ensure that the column names are correct
export function nameof<TObject>(obj: TObject, key: keyof TObject): string;
export function nameof<TObject>(key: keyof TObject): string;
export function nameof(key1: unknown, key2?: unknown): unknown {
  return key2 ?? key1;
}
